var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-lazy-container',{staticClass:"container",attrs:{"tag-name":"div"},on:{"change":_vm.visibilityChange}},[_c('SectionTitle',{attrs:{"title":_vm.title,"reder-time":_vm.rederTime}}),_c('div',{ref:"chart",staticClass:"chart"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }